import i18n from "@Shared/@i18n";
import { computed, defineComponent, toRefs } from "@vue/composition-api";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { delay } from "@Shared/@Utils/utils";
import { nextTick } from "process";
import VueScrollTo from "vue-scrollto";
export default defineComponent({
  name: "ActionButton",
  props: {
    canGoBack: {
      type: Boolean,
      default: true
    },
    canSave: {
      type: Boolean,
      default: true
    },
    canSubmit: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Boolean,
      default: false
    },
    submitting: {
      type: Boolean,
      default: false
    },
    isSubmitPage: {
      type: Boolean,
      default: false
    },
    isSummaryPage: {
      type: Boolean,
      default: false
    },
    displayPrevious: {
      type: Boolean,
      default: true
    },
    displayNext: {
      type: Boolean,
      default: true
    }
  },
  setup(props, {
    emit
  }) {
    const {
      submitting,
      isSubmitPage,
      canSave,
      canSubmit,
      isSummaryPage
    } = toRefs(props);
    const {
      APPLICATION_IS_LOCKED
    } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.APPLICATION_IS_LOCKED]);
    const saveText = computed(() => {
      if (APPLICATION_IS_LOCKED.value) return i18n.t("global.words.continue");
      if (submitting.value) return `${i18n.t("application.messages.submitting")}...`;
      if (isSubmitPage.value) return i18n.t("application.actions.submitApplication");
      return i18n.t("global.actions.saveAndContinue");
    });
    const disableSaveButton = computed(() => !APPLICATION_IS_LOCKED.value && !canSave.value && !canSubmit.value);
    const handleClick = async event => {
      if (!disableSaveButton.value) return emit("save", event);
      emit("show-errors");
      let element = null;
      if (isSummaryPage.value) {
        element = document.querySelector(".fa-exclamation-circle");
      } else {
        await delay(100);
        element = document.querySelector(".material-layout--error-message") || document.querySelector(".material-layout--input--invalid-icon");
      }
      if (element) scrollTo(element);
    };
    const scrollTo = element => {
      nextTick(() => {
        VueScrollTo.scrollTo(element, 400, {
          force: true,
          offset: -180,
          cancelable: true
        });
      });
    };
    return {
      saveText,
      disableSaveButton,
      handleClick
    };
  }
});